/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import React, { useEffect } from "react";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import { BorderRight } from "@mui/icons-material";
import { type } from "@testing-library/user-event/dist/type";

function DataTableBodyCell({ isOddWeek, noBorder, align, children }) {
  const isPlanning =
    typeof children?.props?.column?.info === "string" &&
    children?.props?.column?.info.includes("planning");

  const isRatio =
    typeof children?.props?.column?.info === "string" &&
    children?.props?.column?.info.includes("ratio");

  const isWorkers =
    typeof children?.props?.column?.info === "string" &&
    children?.props?.column?.info.includes("workers");

  const status =
    typeof children?.props?.column?.info === "string" &&
    children?.props?.column?.info.includes("status");

  const preparation =
    typeof children?.props?.column?.last === "string" &&
    children?.props?.column?.last?.includes("preparation");

  const firstLine = children?.props?.row?.id === "0";
  const secondLine = children?.props?.row?.id === "1";
  const thirdLine = children?.props?.row?.id === "2";

  return (
    <MDBox
      component="td"
      textAlign={align}
      py={1.5}
      px={1.5}
      position="relative"
      sx={({ palette: { light }, typography: { size }, borders: { borderWidth } }) => ({
        fontSize: size.sm,
        borderRight: isWorkers ? `${borderWidth[1]} solid ${light.main}` : "none",
        borderBottom:
          isRatio || status || (preparation && thirdLine && !firstLine && !secondLine)
            ? "none"
            : `${borderWidth[1]} solid ${light.main}`,
        background: isOddWeek && "#f2f2f2",
      })}
    >
      {isPlanning || isRatio ? (
        children
      ) : (
        <MDBox
          display="inline-block"
          width="max-content"
          color="text"
          sx={{ verticalAlign: "middle" }}
        >
          {children}
        </MDBox>
      )}
    </MDBox>
  );
}

// Setting default values for the props of DataTableBodyCell
DataTableBodyCell.propTypes = {
  isOddWeek: PropTypes.bool, // Add this prop type for isOddWeek
  children: PropTypes.node.isRequired,
  noBorder: PropTypes.bool,
  align: PropTypes.oneOf(["left", "right", "center"]),
};

DataTableBodyCell.defaultProps = {
  isOddWeek: false, // Default value if not passed
  noBorder: false,
  align: "left",
};

export default DataTableBodyCell;
